import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { Autocomplete, TableFooter, TextField } from "@mui/material";
import { AppraisalAssetsModel, AppraisalDetailsModelForDLorDA, AppraisalsDetailsModelForEquity } from "../../../all_Interfaces";
import { useAppSelector } from "../../../redux/hooks";
import currencySymbolMap from "currency-symbol-map";
import { useEffect, useState } from "react";
import { updateAppraisalAssets } from "../../../redux/slices/AppraisalAssetsSlice";
import { useDispatch } from "react-redux";

export const DebtAssetsAssetList = (props:any) => {

  const dispatch = useDispatch();
  const [rows, setRows] = useState<AppraisalAssetsModel[]>([]);
  const appraisalDetails: AppraisalDetailsModelForDLorDA = useAppSelector(
    (state) => state.AppraisalDetailsForDLorDA.data
  );

  const assets: AppraisalAssetsModel[] = useAppSelector(
    (state) => state.AppraisalAssets.data
  );

  const [currencySymbol, setCurrencySymbol] = useState<string>("");

  useEffect(() => {
    if (Array.isArray(assets)) {
      setRows(assets);
    }
  }, [assets]);


  useEffect(() => {
    if (appraisalDetails !== appraisalDetails as {} || appraisalDetails.currencySelected != "") {
      if (appraisalDetails.currencySelected != "ZH") {
        setCurrencySymbol(
          currencySymbolMap(appraisalDetails.currencySelected) as string
        );
      } else {
        setCurrencySymbol("ZH");
      }
    }else{
      setCurrencySymbol(currencySymbolMap("USD") as string)
    }
    
    // if(rows.length === 1){
    //   var localAssets:AppraisalAssetsModel[] = [...rows];
    //   localAssets[0] = {...localAssets[0],currentAppraisalValue:appraisalDetails.currentAppraisalValue};
    //   dispatch(updateAppraisalAssets(localAssets));
    // }
  }, [appraisalDetails]);

  console.log("from asset", appraisalDetails);

  const formatNumberWithCommas = (num: number | string | null) => {
    if(num != null)
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');

    return '';
  }

  const handleCurrentAppraisalValueChange = (value: string, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
    const tempRows: AppraisalAssetsModel[] = [...rows];
    tempRows[i] = { ...rows[i], currentAppraisalValue: formatedValue };
    setRows(tempRows);
    dispatch(updateAppraisalAssets(tempRows));
    }
  }

  const handleLastDebtValueChange =  (value: string, i: any) => {
    const plainNumber = value.replace(/,/g, '');
    if (!isNaN(Number(plainNumber))) {
      var formatedValue = formatNumberWithCommas(plainNumber);
    const tempRows: AppraisalAssetsModel[] = [...rows];
    tempRows[i] = { ...rows[i], lastAppraisedValue: formatedValue };
    setRows(tempRows);
    dispatch(updateAppraisalAssets(tempRows));
    }
  }

  return (
    <TableContainer component={Paper}>
      <Table className="appraisal-assets-list-table">
        <TableHead>
          
          <TableRow>
            <TableCell>Asset ID </TableCell>
            <TableCell>Asset Name</TableCell>
            <TableCell>Current Debt value </TableCell>
            <TableCell>Last Debt Value </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((asset:AppraisalAssetsModel,index:any) => (
            <TableRow>
            <TableCell>{asset.id}</TableCell>
            <TableCell>{asset.name}</TableCell>

            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  id="outlined-adornment-amount"
                  type="text"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  value={formatNumberWithCommas(asset.currentAppraisalValue)}
                  onChange={(e) => handleCurrentAppraisalValueChange(e.target.value,index)}
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  id="outlined-adornment-amount"
                  type="text"
                  readOnly = {!props.postEditForAdmin}
                  className="Autopopulatefield"
                  value={formatNumberWithCommas(asset.lastAppraisedValue)}
                  onChange={(e) => handleLastDebtValueChange(e.target.value,index)}
                  startAdornment={
                    <InputAdornment position="start">{currencySymbol}</InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>

          </TableRow>
          ))}
          
        </TableBody>
        {rows.length === 0 &&
          
          <TableFooter>
            <TableRow><TableCell align="center" colSpan={9}><p className="EmptyGrid">No historical data</p></TableCell></TableRow> 
        </TableFooter>
          }
      </Table>
    </TableContainer>
  );
};
